import React from 'react';
import { FreeCancellationFlightSummaryMeta, PrimeDaysBanner, PrimeDaysPill, MetaFlowProvider, PageContainer, FlightSummaryMetaProvider } from '@edreamsodigeo/frontend-checkout';
import { PrimeDatalayerTracking } from '@edreamsodigeo/frontend-prime';
import { TripSummaryTrackingProvider } from '../../providers/tracking';
import { Portal, PortalAsync } from '@edreamsodigeo/frontend-core';
import TripSummaryTranslationsPageProvider from './TranslationsPageProvider';
import { PrimeEqualProminenceMobileWrapper } from '../../funnels/FlightResults/components/CheckoutFlightSummaryResults/PrimeEqualProminenceMobileWrapper';
import MembershipProductEvaluation from '../../providers/MembershipProductEvaluationProvider';
import { flightSummaryActions } from '../../boundaries/checkoutFlightSummary';
import { CheckoutFlightSummaryMetaPageProvider } from '../../funnels/FlightResults/components/CheckoutFlightSummaryMeta';
import { PrimeDualPriceStickyBarMobileWrapper } from '../../funnels/FlightResults/components/CheckoutFlightSummaryMeta/PrimeDualPriceStickyBarMobileWrapper';
import PrimeEventManagerProvider from '../../providers/PrimeEventManagerProvider';
import UserVerificationManagerWrapper from './components/UserVerificationManagerWrapper';
import { MetaHotelDealsMobileCardWrapper } from '../../funnels/FlightResults/components/CheckoutFlightSummaryMeta/MetaHotelDealsMobileCard';
const TripSummary = () => /*#__PURE__*/React.createElement(TripSummaryTrackingProvider, null, /*#__PURE__*/React.createElement(TripSummaryTranslationsPageProvider, null, /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "free_cancellation_flightsummary",
  parentId: "free_cancellation_wrapper",
  Component: FreeCancellationFlightSummaryMeta
}), /*#__PURE__*/React.createElement(Portal, {
  elementId: "prime_days_banner_campaign",
  Component: PrimeDaysBanner
}), /*#__PURE__*/React.createElement(Portal, {
  elementId: "prime_days_pill_campaign",
  Component: PrimeDaysPill
}), /*#__PURE__*/React.createElement(Portal, {
  elementId: "welcome-back-to-prime-modal",
  Component: UserVerificationManagerWrapper
}), /*#__PURE__*/React.createElement(MetaFlowProvider, {
  isMeta: true
}, /*#__PURE__*/React.createElement(FlightSummaryMetaProvider, {
  regex: /.*flightsummary\/(.*)/
}, /*#__PURE__*/React.createElement(PrimeEventManagerProvider, null, /*#__PURE__*/React.createElement(MembershipProductEvaluation, {
  funnel: 'flights'
}, /*#__PURE__*/React.createElement(CheckoutFlightSummaryMetaPageProvider, {
  onContinueWithFlight: flightSummaryActions.onContinueWithFlight
}, /*#__PURE__*/React.createElement(PrimeDatalayerTracking, null), /*#__PURE__*/React.createElement(PageContainer, null, /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "meta_hotel_deals_mobile_card_wrapper",
  parentId: "flight-summary",
  Component: MetaHotelDealsMobileCardWrapper
}), /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "prime_equal_prominence_mobile_wrapper",
  parentId: "prime_equal_prominence_mobile_wrapper_container",
  Component: PrimeEqualProminenceMobileWrapper
}), /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "prime_equal_prominence_v2_mobile_wrapper",
  parentId: "prime_equal_prominence_v2_mobile_wrapper_container",
  Component: PrimeDualPriceStickyBarMobileWrapper
})))))))));
export default TripSummary;